export interface PaperlessDocumentsToSave {
  paperlessDocumentIds: number[];
  sentPaperlessDocument: boolean;
}

export function hasPaperlessDocuments(
  paperlessDocumentIds?: number[]
): boolean {
  return !!paperlessDocumentIds && paperlessDocumentIds.length > 0;
}

export function paperlessDocumentsToSave(
  sentPaperlessDocument: boolean,
  paperlessDocumentIds?: number[]
): PaperlessDocumentsToSave {
  const ids =
    sentPaperlessDocument && paperlessDocumentIds ? paperlessDocumentIds : [];
  return {
    paperlessDocumentIds: ids,
    sentPaperlessDocument: hasPaperlessDocuments(ids)
  };
}
